import { useIntl } from 'react-intl';
import SingleLoanServices from "services/services/SingleLoanServices";

export const trimValue = (input:any) => {
	return input?.replace(/\s+/g, " ");
}

export const encodeQueryData = (data:any) => {
    // encoding query strings
    const ret = [];
    for (let d in data){
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
    }      
    return ret?.join("&");
};

export const convertToObjectKeyString = (stringData:any) => {
    let stringsReplace=[
        "[",
        "&",
        "\\/",
        "/",
        "#",
        "^",
        "+",
        "(",
        ")",
        "$",
        "~",
        "%",
        ".",
        "'",
        '"',
        ":",
        "*",
        "?",
        "<",
        ">",
        "{",
        "}",
        "!",
        "@",
        "]",
        ","
    ];
    
    stringsReplace?.forEach((element:any) => {
        stringData = stringData?.trim()?.split(element)?.join("");
    });
    return stringData?.trim()?.toLowerCase().replaceAll(" - ","_").replaceAll(" -","_").replaceAll(" ","_").replaceAll("-","_");
};

export const TranslateString = (string:any) => {
    const intl=useIntl();
    let key = convertToObjectKeyString(string);
    
    
    let value = intl.formatMessage({id: key});
    if(value===key){
        // console.log('translate',"\""+key+"\": \""+string+"\",")
    }
    // return value;
    return (value===key) ? string : value;
};

export const StatusFind = (arr:any, val:any) => {
    let statusLabel = arr.find((data:any)=>data.value === val)
    return statusLabel?.label
};

export const SelectFill = (arr:any, val:any) => {
    let SelectValue = arr.find((data:any)=>data.value === val)
    return SelectValue?.value ? [SelectValue?.value] : []
};

export const downloadBlob = async(docId:any) => {
    await SingleLoanServices
    .downloadFile(docId) 
    .then( async (response) => {
        if (response?.data?.code === 200 && (response?.data?.file != '' || response?.data?.file?.length > 0)) {
            const byteCharacters = atob(response?.data?.file);
            const data = response?.data?.data;
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: ''});
            let fileURL = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.download = data.originalName;
            link.href = fileURL;
            link.click();
            link.remove();
        }

    }).catch((err: any) => {
        console.log(err)
    });
}
export const downloadSettingsBlob = async(id:any) => {
    await SingleLoanServices
    .downloadSettingsFile(id) 
    .then( async (response) => {
        if (response?.data?.code === 200 && (response?.data?.file != '' || response?.data?.file?.length > 0)) {
            const byteCharacters = atob(response?.data?.file);
            const data = response?.data?.data;
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: ''});
            let fileURL = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.download = data.originalName;
            link.href = fileURL;
            link.click();
            link.remove();
        }

    }).catch((err: any) => {
        console.log(err)
    });
}